import * as React from "react";
import styled, { css } from "styled-components";

import { IApiError } from "src/library/utils";

import Grid from "../Hedron";
import { Button } from "../Button";
import { Text } from "../Text/Text";

interface PageErrorDetailsProps {
  error: IApiError | null;
}

const PageErrorDetails: React.ReactFCWithChildren<PageErrorDetailsProps> = props => {
  const [ showError, setShowError ] = React.useState(false);

  if (props.error) {
    return (
      <PageErrorDetailsWrapper direction="vertical">
        <Button
          $buttonType="error"
          onClick={() => setShowError(!showError)}
        >
          {showError ? "Hide Error Details" : "Show Error details"}
        </Button>

        {showError && (
          <Container>
            <TitleWrapper>
              <Text
                as="h3"
                fontSize="h3"
              >
                {props.error.title}
              </Text>
            </TitleWrapper>

            <Text>
              {props.error.message}
            </Text>
          </Container>
        )}
      </PageErrorDetailsWrapper>
    );
  }

  return null;
};

const Container = styled(Grid.Box)`
  ${({ theme }) => css`
    background: ${theme.colors.errorLight};
    border-radius: ${theme.borderRadius};
    padding: ${theme.spacing.padding.md};
    margin-top: ${theme.spacing.margins.md};
    border: ${theme.colors.error} 1px solid;
  `}
`;

const PageErrorDetailsWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    width: 300px;
    margin-top: ${theme.spacing.margins.md};
    text-align: center;

    button {
      width: 160px;
      margin: auto;
    }
  `}
`;

const TitleWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.padding.sm};
  width: 100%;
`;

export default PageErrorDetails;
